import React from 'react';
import injectSheet from 'react-jss';

import { BASE_COLOR } from 'shared/constants/colors';
import { noop } from 'shared/helpers';
import { mixClasses as cx, mixStyles as sx } from 'helpers';

import { SvgIcon } from 'components/elems';
import { BlogComposer } from './blog';


const ICON_SIZE = 42;

const BlogModuleIcon = () => (
  <div
    className="fw2"
    style={{
      fontSize: ICON_SIZE,
      color: BASE_COLOR.caretBlue
    }}
  >
    Aa
  </div>
);

// TODO: Switch these out w/ emotion
const PhotoModuleIcon = injectSheet({
  root: {
    '& > path:not(:last-child), & > circle': {
      stroke: '#ff56fa',  // One off purple ish color
    },
  },
})(props => (
  <SvgIcon.strl.CameraBoxL
    className={props.classes.root}
    size={ICON_SIZE - 2}
  />
));

const PlaylistModuleIcon = injectSheet({
  root: {
    '& > g path': {
      stroke: '#33da30',  // Spotify ish green color
    },
  },
})(props => (
  <SvgIcon.strl.MusicNote1L
    className={props.classes.root}
    size={ICON_SIZE - 2}
  />
));


const handleClickWithModuleId = (handlerFunc, moduleId) => (e) => (
  handlerFunc(e, moduleId)
);

let ModuleChoiceBtn = ({
  icon,
  label,
  size = 80,
  classes: cn,
  style = {},
  className,
  hasLeftDivider = false,
  onClick = noop,
  moduleId,
  ...props
}) => {
  return (
    <div
      className={cx(
        cn.root,
        {[cn.leftDivider]: hasLeftDivider},
        "relative tc black-60 ma2 pointer",
        className,
      )}
      style={sx( style, {width: size, height: size} )}
      onClick={handleClickWithModuleId(onClick, moduleId)}
      {...props}
    >
      <div className={cx(
        cn.iconCon, "h-75 flex flex-column justify-center items-center"
      )}>
        {icon}
      </div>

      <div className={cx(
        cn.labelCon, "h-25 f6 black-40"
      )}>
        {label}
      </div>
    </div>
  );
};
ModuleChoiceBtn = injectSheet({
  root: {
    // NOTE(t10u): transition 'all' fucks with StaggeredMotion?
    transition: 'color 150ms ease-in-out',
    transform: 'translate3d(0, 0, 0)',
    '&:hover > div': {
      color: BASE_COLOR.black
    },
    '&:hover > :first-child': {
      transform: 'translate3d(0, -4px, 0)',
    },
  },
  iconCon: {  transition: 'all 150ms ease-in-out', },
  labelCon: { transition: 'all 150ms ease-in-out', },
  leftDivider: {
    '&:before': {
      content: '"/"',
      position: 'absolute',
      top: '45%',
      left: '-14%',
      opacity: '0',
      animation: 'opacityFadeInFull 150ms ease-in-out 500ms 1 forwards',
      color: BASE_COLOR.lightGray,
      fontWeight: 200,
    },
  },
})(ModuleChoiceBtn);



// TODO: Add Todo module, rolodex module
export const BlogModuleBtn = ({ style, ...props }) => (
  <ModuleChoiceBtn
    icon={<BlogModuleIcon />}
    label="Write"
    style={style}
    moduleId={BlogComposer.moduleId}
    {...props}
  />
);
export const AlbumModuleBtn = ({ style, ...props }) => (
  <ModuleChoiceBtn
    icon={<PhotoModuleIcon />}
    label="Photos"
    style={style}
    hasLeftDivider
    {...props}
  />
);
export const PlaylistModuleBtn = ({ style, ...props }) => (
  <ModuleChoiceBtn
    icon={<PlaylistModuleIcon />}
    label="Playlist"
    style={style}
    hasLeftDivider
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/modules/moduleChoiceBtns.js